import { Injectable } from '@angular/core';
import { ConfirmServiceInterface } from '@ideapa/app-common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService implements ConfirmServiceInterface {
  constructor(private modal: NgbModal) {}

  public confirm(
    message: string = 'Sei sicuro?',
    title: string = '',
    cancelText: string = 'Annulla',
    okText: string = 'Ok'
  ) {
    const dialogRef = this.modal.open(ConfirmDialogComponent, {
      size: 'md',
      backdrop: 'static',
    });

    const instance = dialogRef.componentInstance as ConfirmDialogComponent;

    instance.message = message;
    instance.title = title;
    instance.cancelText = cancelText;
    instance.okText = okText;

    return dialogRef.result as Promise<boolean>;
  }
}
